import requestAction from '../../utils/requestAction'

export const fetchPreorders = (params?: string) =>
  requestAction('PREORDER_LIST', params)(`preorders`, 'GET')
